// Auto-generated by scripts/update-monaco-version.cjs
export const MONACO_VERSION = '0.55.1';
